<template>
	<div class="container">
		<b-overlay :show="loading" no-wrap rounded></b-overlay>
		<b-row>
			<b-col>
				<b
					>#{{ tsData.serviceNumber }} -
					{{ tsData.serviceType.name }} [{{ tsData.trip }}] </b
				><br />
			</b-col>
		</b-row>
		<section v-if="tsData.paymentStatus === 'pending'">
			<b-alert variant="warning" show class="mt-3">
				<h5 class="text-center">
					El precio ya que está vinculado a un pago
				</h5>
			</b-alert>
		</section>
		<section>
			<b-row class="mt-2">
				<b-col cols="12">
					<b-form-group id="input-group-1" label-for="input-1">
						<label class="mr-sm-2">{{type[model.type]}}</label>

						<b-input-group size="lg" prepend="$">
							<b-form-input
								v-model="model.amount"
								type="number"
							></b-form-input>
							<b-input-group-append>
								<b-form-select
									:disabled="blockCurrencySelect"
									:options="optsCurrencies"
									class="h-auto"
									v-model="model.currency"
								></b-form-select>
							</b-input-group-append>
						</b-input-group>
						<b-form-checkbox
							v-model="model.priceOverride"
							name="checkbox-1"
							value="true"
							unchecked-value="false"
						>
							Mantener precio
						</b-form-checkbox>
						<label v-if="blockCurrencySelect" class="text-danger">Se encontró moneda de plan tarifario</label>
					</b-form-group>
				</b-col>
			</b-row>
			<b-row>
				<b-col cols="12">
					<b-form-group label="Motivo">
						<b-textarea v-model="model.reason"></b-textarea>
					</b-form-group>
				</b-col>
			</b-row>
			<b-row class="mt-2">
				<b-col cols="12" class="mx-auto text-right">
					<b-button variant="primary" size="lg" @click="save()"
						>Guardar</b-button
					>
				</b-col>
			</b-row>
		</section>
	</div>
</template>

<script>
import api from "../../../api.js";
export default {
	props: {
		transportServiceId: {
			required: true
		},
		formType: {
			required: true
		},
		type: Object
	},
	data() {
		return {
			loading: false,
			model: {
				currency: '',
				amount: '',
				type: '',
				priceOverride: '',
				reason: ''
			},
			tsData: {
				serviceNumber: -1,
				serviceType: { name: "" },
				tripType: "",
				bookingCurrency: "",
				bookingPriceTotal: 0
			},
			blockCurrencySelect: false
		};
	},
	methods: {
		_fetch() {
			return api(this)
				.get(`/transport-service/${this.transportServiceId}`)
				.then(({data}) => {
					this.tsData = JSON.parse(JSON.stringify(data));
					this.model.type = this.formType
					this.model.reason = ''
					switch (this.formType) {
						case 'booking':
							this.model.currency = data.bookingCurrency
							this.model.amount = data.bookingPriceTotal
							this.model.priceOverride = data.bookingPriceOverride
							break;
						case 'net':
							this.model.currency = data.netCurrency
							this.model.amount = data.netPriceTotal
							this.model.priceOverride = data.netPriceOverride
							break;
						case 'supplier':
							this.model.currency      = data.supplierCurrency
							this.model.amount        = data.supplierPriceTotal
							this.model.priceOverride = data.supplierPriceOverride
							this.getSupplierRatePlanCurrency();
							break;
						default:
							break;
					}
				})
				.catch(this.$root.handleRequestError)
				.finally(() => {
					this.loading = false;
				});
		},
		getSupplierRatePlanCurrency() {
			return api(this)
				.get(`/transport-services/${this.transportServiceId}/get-rate-currency-supplier`)
				.then(({data}) => {
					if (data.currency != '') {
						this.model.currency      = data.currency
						this.blockCurrencySelect = true
					} else {
						this.blockCurrencySelect = false
					}
				})
				.catch(this.$root.handleRequestError)
		},
		setValues(){

		},
		save() {
			if (!this.validateForm()) return;
			this.loading = true;
			api(this)
				.post(
					`/transport-services/${this.transportServiceId}/update-prices`,
					this.model
				)
				.then(() => {
					this.$root.showAlert("Se actualizó correctamente", {
						variant: "success"
					});
					this.saved();
				})
				.catch(this.$root.handleRequestError)
				.finally(() => {
					this.loading = false;
				});

		},
		isEmpty(val) {
			return val === null || val === undefined || val === "";
		},
		validateForm() {
			try {
				if (this.isEmpty(this.model.amount) || this.model.amount <= 0) {
					throw new Error("Monto es requerido");
				}
				if (this.isEmpty(this.model.reason)) {
					throw new Error("Motivo es requerido");
				}
				if (this.isEmpty(this.model.currency)) {
					throw new Error("Currency es requerido");
				}
			} catch (err) {
				this.$root.showAlert(err.message, { variant: "danger" });
				return false;
			}
			return true;
		},
		saved() {
			this.$emit("saved");
		}
	},
	mounted() {
		let init = async () => {
			this.loading = true;
			await this._fetch();
		};
		init();
	},
	computed: {
		optsCurrencies() {
			return this.$root.auxVars.currencyOpts;
		}
	}
};
</script>
